module.exports = __webpack_public_path__ + "img/CSC-logo_text-on-the-right-01.3c186715.png";